export default __webpack_public_path__ + "static/media/foto-diferencial-tablet.22d11477.png";